class ClientComputer {
  constructor(uniqueId, note, extensionId, zoneId, title) {
    this.uniqueId = uniqueId;
    this.note = note;
    this.extensionId = extensionId;
    this.zoneId = zoneId;
    this.title = title;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      allClientComputers: [],
      allClientComputersForOther: [],
      clientComputer: new ClientComputer('', '', null, null, ''),
      clientComputerPaginationList: [],
    };
  },
  methods: {
    getListOfClientComputersForOther: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllClientComputers').then(() => {
        if (this.$store.state.clientComputerModule.successFlag) {
          this.allClientComputersForOther =
            this.$store.state.clientComputerModule.allClientComputers;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.clientComputerModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getListOfClientComputersForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.clientComputerModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getListOfClientComputersForOther();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getAllClientComputers: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getAllClientComputers').then(() => {
        if (this.$store.state.clientComputerModule.successFlag) {
          this.allClientComputers = this.$store.state.clientComputerModule.allClientComputers;
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.clientComputerModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllClientComputers();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.clientComputerModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllClientComputers();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    getListOfClientComputersWithPagination: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getClientComputersWithPagination', {
          pageNumber: this.page,
          pageSize: this.pageSize,
          extensionId: this.searchExtensionId,
          zoneId: this.searchZoneId,
          cityId: this.searchCityId,
          uniqueId: this.searchUniqueId,
          title: this.searchComputerTitle,
        })
        .then(() => {
          if (this.$store.state.clientComputerModule.successFlag) {
            this.clientComputerPaginationList = [];
            let temp = this.$store.state.clientComputerModule.clientComputers;
            for (let i = 0; i < temp.length; i++) {
              let isActive = true;
              if (temp[i].isActive === false) {
                isActive = false;
              }
              let isConfirmed = true;
              if (temp[i].isConfirmed === false) {
                isConfirmed = false;
              }
              this.clientComputerPaginationList.push({
                title: temp[i].title ? temp[i].title : '-',
                note: temp[i].note ? temp[i].note : '-',
                uniqueId: temp[i].uniqueId ? temp[i].uniqueId : '-',
                extension: temp[i].extension ? temp[i].extension.sipExtension : '-',
                active: isActive,
                status: isConfirmed,
                id: temp[i].id,
                city: temp[i].zone && temp[i].zone.city ? temp[i].zone.city.title : '-',
                zone: temp[i].zone ? temp[i].zone.title : '-',
              });
            }
            if (this.load.val) {
              this.load.val = false;
            }
            this.totalPages = Number(this.$store.state.clientComputerModule.totalPages);
            if (this.$refs.pagination) {
              this.$refs.pagination.totalPages = Number(this.$store.state.clientComputerModule.totalPages);
              this.$refs.pagination.totalRecords = Number(this.$store.state.clientComputerModule.totalRecords);
            }
          } else {
            if (this.load.val) {
              this.load.val = false;
            }
            if (this.$store.state.clientComputerModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getListOfClientComputersWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.clientComputerModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getListOfClientComputersWithPagination();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        });
    },
    setTotalPagesFun: function (totalPages) {
      if (this.$refs.pagination) {
        this.$refs.pagination.totalPages = Number(totalPages);
      } else {
        this.setTotalPagesFun(totalPages);
      }
    },
    addClientComputerFunction: function () {
      if (!this.validateAddOrEditForm()) {
        return;
      }
      this.clientComputer.isActive = this.isActive;
      this.clientComputer.isConfirmed = this.isConfirmed;
      this.load.val = true;
      this.$store
        .dispatch('addClientComputer', this.clientComputer)
        .then(() => {
          if (this.$store.state.clientComputerModule.successFlag) {
            this.$refs.confirm.showConfirmDialog = false;
            this.showAddEditModal = false;
            this.disabelConfirm = false;
            this.snackText = ' کامپیوتر با موفقیت اضافه شد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#4CAF50';
            this.snakIcon = 'mdi-check-circle';
            this.isActive = false;
            this.isConfirmed = false;
            this.selectedCity = null;
            this.clientComputer = new ClientComputer('', '', null, null, '');
            this.getListOfClientComputersWithPagination();
          } else {
            this.disabelConfirm = false;

            if (this.$store.state.clientComputerModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.addClientComputerFunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.clientComputerModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.addClientComputerFunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
    getClientComputerFunction: function (id) {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('getClientComputer', id).then(() => {
        if (this.$store.state.clientComputerModule.successFlag) {
          let temp = this.$store.state.clientComputerModule.clientComputer;
          this.clientComputer.id = temp.id;
          this.clientComputer.title = temp.title;
          this.clientComputer.note = temp.note;
          this.clientComputer.uniqueId = temp.uniqueId;
          this.clientComputer.extensionId = temp.extension ? temp.extension.id : null;
          this.selectedCity = temp.zone && temp.zone.city ? temp.zone.city.id : null;
          this.clientComputer.zoneId = temp.zone ? temp.zone.id : null;
          this.cityChange2();
          if (temp.isActive == false) {
            this.isActive = false;
          } else {
            this.isActive = true;
          }
          if (temp.isConfirmed == false) {
            this.isConfirmed = false;
          } else {
            this.isConfirmed = true;
          }
          if (this.load.val) {
            this.load.val = false;
          }
        } else {
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.clientComputerModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getClientComputerFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.clientComputerModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getClientComputerFunction(id);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    editClientComputerFunction: function () {
      if (!this.validateAddOrEditForm()) {
        return;
      }
      this.clientComputer.isActive = this.isActive;
      this.clientComputer.isConfirmed = this.isConfirmed;
      this.load.val = true;
      this.$store
        .dispatch('editClientComputer', this.clientComputer)
        .then(() => {
          if (this.$store.state.clientComputerModule.successFlag) {
            this.$refs.confirm.showConfirmDialog = false;
            this.disabelConfirm = false;
            this.showAddEditModal = false;
            if (this.load.val) {
              this.load.val = false;
            }
            this.getListOfClientComputersWithPagination();
            this.snackText = ' کامپیوتر با موفقیت ویرایش شد';
            this.$refs.snackRef.snackModel = true;
            this.snackColor = '#4CAF50';
            this.snakIcon = 'mdi-check-circle';
            this.isActive = false;
            this.isConfirmed = false;
            this.selectedCity = null;
            this.clientComputer = new ClientComputer('', '', null, null, '');
          } else {
            this.disabelConfirm = false;
            if (this.$store.state.clientComputerModule.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.editClientComputerFunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.clientComputerModule.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.editClientComputerFunction();
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.showError();
            }
          }
        })
        .finally(() => {
          this.load.val = false;
        });
    },
    deleteClientComputerFunction: function () {
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('deleteClientComputer', this.clientComputerId).then(() => {
        if (this.$store.state.clientComputerModule.successFlag) {
          this.disabelConfirm = false;
          this.$refs.confirm.showConfirmDialog = false;
          if (this.load.val) {
            this.load.val = false;
          }
          this.getListOfClientComputersWithPagination();
          this.snackText = ' کامپیوتر با موفقیت حذف شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.clientComputerModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.deleteClientComputerFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.clientComputerModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.deleteClientComputerFunction();
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    addClientComputerRequestFunction: function (note, uniqueId) {
      let data = {
        uniqueId: uniqueId,
        note: note,
      };
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store.dispatch('addClientComputerRequest', data).then(() => {
        if (this.$store.state.clientComputerModule.successFlag) {
          this.snackText = ' درخواست با موفقیت اضافه شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
          if (this.load.val) {
            this.load.val = false;
          }
          this.requestAdded(uniqueId);
        } else {
          this.disabelConfirm = false;
          if (this.load.val) {
            this.load.val = false;
          }
          if (this.$store.state.clientComputerModule.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.addClientComputerRequestFunction(note, uniqueId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.clientComputerModule.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.addClientComputerRequestFunction(note, uniqueId);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.showError();
          }
        }
      });
    },
    validateAddOrEditForm: function () {
      const isTitleEmpty =
        !this.clientComputer.title?.replace(/\s/g, '').length || !this.clientComputer.title;
      if (isTitleEmpty) {
        this.showErrorAlert('عنوان کامپیوتر نمی تواند خالی باشد');
        this.disabelConfirm = false;
        return;
      }
      if (!this.clientComputer.uniqueId) {
        this.showErrorAlert('شناسه نمی تواند خالی باشد');
        this.disabelConfirm = false;
        return;
      }
      if (!this.clientComputer.zoneId) {
        this.showErrorAlert('ناحیه نمی تواند خالی باشد');
        this.disabelConfirm = false;
        return;
      }
      return true;
    },
    showError: function () {
      this.snackText = this.$store.state.clientComputerModule.error;
      this.$refs.snackRef.snackModel = true;
      this.snackColor = '#FF5252';
      this.snakIcon = 'mdi-information';
    },
  },
};
